import { defineMessages } from 'react-intl';

export default defineMessages({
  dollarOffMessaging: {
    id: 'ProgressBar.dollarOffMessaging',
    description: 'Message for the price promo codes add option',
    // eslint-disable-next-line no-template-curly-in-string
    defaultMessage: '${dollarOffAmount} OFF',
  },
});